var React = require('react');

function IconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 19H19V24C19 24.55 18.55 25 18 25C17.45 25 17 24.55 17 24V19H12C11.45 19 11 18.55 11 18C11 17.45 11.45 17 12 17H17V12C17 11.45 17.45 11 18 11C18.55 11 19 11.45 19 12V17H24C24.55 17 25 17.45 25 18C25 18.55 24.55 19 24 19Z","fill":"#AFB2B8"}));
}

IconInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = IconInline;

IconInline.default = IconInline;
